module.exports = __webpack_public_path__ + "static/debbie-59f5306eb8ea1ed4d200be946b23a907.png";